import { Component } from '@angular/core';
import { Portal, PortalModule } from '@angular/cdk/portal';
import { SidePanelContentService } from '@galaxy/crm/static';
import { CommonModule } from '@angular/common';
import { Observable } from 'rxjs';

@Component({
  selector: 'crm-sidenav-content',
  templateUrl: 'crm-sidenav-content.html',
  styleUrls: ['crm-sidenav-content.scss'],
  imports: [PortalModule, CommonModule],
})
export class SidenavContentComponent {
  content$: Observable<Portal<any> | null>;

  constructor(private readonly content: SidePanelContentService) {
    this.content$ = this.content.getContent();
  }
}
